module.exports = __webpack_public_path__ + "public/SiteIcons/hostingBlockImage1.png?7acf7c6a";